module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/fukidashi_pink-a1dfa0abd8522c49c303cb0d95fcce64.svg";